<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Edit Message - {{ id }}
        </v-toolbar-title>
      </v-toolbar>
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">Select Time Period</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">Configure Notification</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Target Notification</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card flat class="mb-12" height="450px">
              <v-card-text style="text-align: center;">
                <v-row>
                  <v-col>
                    <div>Start Date</div>
                    <v-date-picker color="green" v-model="startDate" :allowed-dates="allowedStartDates" @change="onStartDateChanged"></v-date-picker>
                  </v-col>
                  <v-col>
                    <div>End Date</div>
                    <v-date-picker color="red" v-model="endDate" :allowed-dates="allowedEndDates" showCurrent="false"></v-date-picker>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-spacer style="margin-top: 90px;"></v-spacer>
            <div>
              <span style="float: right;">
                <v-btn class="mr-5" color="primary" @click="step = 2">Next</v-btn>
                <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
              </span>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card flat class="mb-12" height="450px">
              <v-row>
                <v-col style="padding: 0 24px 0 24px;">
                  <div style="aligner-items: stretch; display: flex;">
                    <v-sheet tile elevation="5" class="pa-3" color="green">
                      <div style="text-align: center">
                        <div>Starts On</div>
                        <div><b>{{startDate}}</b></div>
                      </div>
                    </v-sheet>
                    <hr class="v-divider theme--light" style="align-self: center; margin: 0 12px;">
                    <v-sheet tile elevation="5" class="pa-3" color="red">
                      <div style="text-align: center">
                        <div>Ends On</div>
                        <div><b>{{endDate}}</b></div>
                      </div>
                    </v-sheet>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-10">
                <v-col>
                  <v-text-field
                    label="Header"
                    outlined
                    counter
                    maxlength="75"
                    :rules="[rules.required]"
                    v-model="header"
                  >
                  </v-text-field>
                  <v-textarea
                    label="Body"
                    rows="3"
                    outlined
                    counter
                    maxlength="200"
                    :rules="[rules.required]"
                    v-model="body"
                    style="margin-top:10px;"
                  >
                  </v-textarea>
                  <v-textarea
                    label="Call to Action"
                    rows="3"
                    outlined
                    counter
                    maxlength="200"
                    :rules="[rules.required]"
                    v-model="callToAction"
                    style="margin-top:10px;"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card>
            <v-spacer style="margin-top: 90px;"></v-spacer>
            <div>
              <v-btn class="mr-5" color="primary" @click="step = 1">Previous</v-btn>
              <span style="float: right;">
                <v-btn class="mr-5" color="primary" @click="step = 3">Next</v-btn>
                <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
              </span>
            </div>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-card flat class="mb-12" height="450px">
              <v-row>
                <v-col>
                  <v-select
                    outlined
                    label="Market"
                    v-model="market"
                    :items="markets"
                    :rules="[rules.required]"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-card>
            <v-spacer style="margin-top: 90px;"></v-spacer>
            <div>
              <v-btn class="mr-5" color="primary" @click="step = 2">Previous</v-btn>
              <span style="float: right;">
                <v-btn
                  color="green"
                  :disabled="saveDisabled"
                  @click="onSaveClick"
                  :loading="busy"
                  class="mr-5"
                >
                  Save
                </v-btn>
                <v-btn
                  color="green"
                  class="mr-5"
                  :disabled="saveDisabled"
                  @click="onSaveAndSubmitClick"
                  :loading="busy"
                >
                  Save and Submit
                </v-btn>
                <v-btn
                  color="grey lighten-1"
                  @click="onCloseClick()"
                >
                  Cancel
                </v-btn>
              </span>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
const moment = require('moment');

export default {
  props: {
    dialog: Boolean,
    id: String,
    startDate: String,
    endDate: String,
    header: String,
    body: String,
    callToAction: String,
    market: String,
  },

  data() {
    return {
      markets: [],

      rules: {
        required: value => !!value || 'Required',
      },

      busy: false,
      step: 1,
    };
  },

  computed: {
    saveDisabled() {
      return !(this.startDate && this.endDate && this.header && this.body && this.callToAction && this.market);
    },
  },

  mounted() {
    this.getMarkets();
  },

  methods: {
    allowedStartDates(val) {
      return moment(val).isSameOrAfter(new Date().toISOString().substr(0, 10));
    },

    allowedEndDates(val) {
      return moment(val).isSameOrAfter(this.startDate);
    },

    onStartDateChanged() {
      if (moment(this.startDate).isAfter(this.endDate)) {
        this.endDate = this.startDate;
      }
    },

    getMarkets() {
      const options = {
        method: 'get',
        url: '/read/aligner_countries/v1',
      };

      this.axios(options)
        .then((res) => {
          this.markets = res.data.map(cur => cur.countryCode);
        })
        .catch((err) => {
          console.log(`fetching countries error: ${err.message}`);
        });
    },

    reset() {
      this.step = 1;
      this.header = null;
      this.body = null;
      this.callToAction = null;
      this.market = null;
    },

    onCloseClick() {
      this.$emit('close', null);
      this.reset();
    },

    onSaveClick() {
      this.busy = true;

      const options = {
        method: 'post',
        url: '/update/message/v1',
        data: {
          id: this.id,
          payload: {
            schedule: {
              startDate: moment.utc(this.startDate).startOf('day'),
              endDate: moment.utc(this.endDate).endOf('day'),
            },
            header: this.header,
            body: this.body,
            callToAction: this.callToAction,
            targets: {
              market: this.market,
              softwareVersion: 'all',
            },
            issuerUsername: this.$store.state.auth.token.user.username,
            issuerEmail: this.$store.state.auth.token.user.email,
            disposition: 'draft',
          },
        },
      };

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.reset();
          this.$emit('close', true);
        })
        .catch((err) => {
          this.busy = false;
          console.log(`update message error: ${err.message}`);
          this.reset();
          this.$emit('close');
        });
    },

    onSaveAndSubmitClick() {
      this.busy = true;

      const options = {
        method: 'post',
        url: '/update/message/v1',
        data: {
          id: this.id,
          payload: {
            schedule: {
              startDate: moment.utc(this.startDate).startOf('day'),
              endDate: moment.utc(this.endDate).endOf('day'),
            },
            header: this.header,
            body: this.body,
            callToAction: this.callToAction,
            targets: {
              market: this.market,
              softwareVersion: 'all',
            },
            issuerUsername: this.$store.state.auth.token.user.username,
            issuerEmail: this.$store.state.auth.token.user.email,
            disposition: 'pending approval',
          },
        },
      };

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.reset();
          this.$emit('close', true);
        })
        .catch((err) => {
          this.busy = false;
          console.log(`update message error: ${err.message}`);
          this.reset();
          this.$emit('close');
        });
    },
  },
};
</script>
